import { defineStore } from 'pinia'

const useChart = defineStore('chart', () => {
  const hashes = ref<string[]>([])

  const setHashes = (value: string[]) => {
    hashes.value = value
  }

  return { hashes, setHashes }
})

export default useChart
